/**
 * Shared product mockup shot used in the hero and the pricing card.
 * Replace with an updated render whenever the package changes.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/5bDP3ztfz69sT1hgCzXyYh/hf_20260922_130448_79efdeb2-2039-4d19-a501-e169c609084a.png'

/** Where every buy button sends the coach. */
export const CHECKOUT_URL = 'https://bootcamp-ready.impultienda.ar/checkout'

export const PRODUCT_MOCKUP_ALT =
  'The Decided Bootcamp: six volumes — four dated quarterly calendars plus the Adaptation Matrix and the Coaching & Retention Playbook — and five bonuses, shown on desktop, tablet and phone'
